export const ADD_BOARD_INSTRUCTION_HASH = '#botAdd'

export const VIEWS_EXTRA_GUID = '3f3f3503-a2fd-4d25-b087-8c7536d29778'
export const FORWARDS_EXTRA_GUID = '9213ecc7-c02c-44f9-b872-a3bc07ac63cd'
export const COMMENTS_EXTRA_GUID = '31fa8f24-959e-4713-8a9a-7050c52ae92a'

